module.exports = __webpack_public_path__ + "img/Schulmaterial_Russlandvonoben.2d397764.png";